module.exports = __webpack_public_path__ + "img/img4a.2ce1ecaf.jpg";